import { render, staticRenderFns } from "./SupplierRawMaterialEnzymesCatalysts.vue?vue&type=template&id=00c953d9&scoped=true"
import script from "./SupplierRawMaterialEnzymesCatalysts.vue?vue&type=script&lang=js"
export * from "./SupplierRawMaterialEnzymesCatalysts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c953d9",
  null
  
)

export default component.exports